<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <div>
      <el-date-picker
        v-model="time"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="train_load_excel()">详情导出</el-button>
          <el-button type="primary" @click="train_load_pdf('')" >批量导出</el-button>
    </div>
    <el-table stripe :data="train_list.data" :row-style="{height:'70px'}" style="width: 100%;margin-top: 20px;" :row-key="train_choiced_click" @selection-change="train_choiced_change">
      <el-table-column type="selection">
      </el-table-column>
      <el-table-column label="编号" prop="num" width="" sortable>
      </el-table-column>
      <el-table-column prop="name" label="主题" sortable>
      </el-table-column>
      <el-table-column label="分类" prop="t_id" width="" sortable>
      </el-table-column>
      <el-table-column label="派发人" prop="a_id" width="" sortable>
      </el-table-column>
      <el-table-column label="开始时间" prop="start_time" width="" sortable>
      </el-table-column>
      <el-table-column label="结束时间" prop="end_time" width="" sortable>
      </el-table-column>
      <el-table-column label="学员数" prop="companyee" width="" sortable>
      </el-table-column>
      <el-table-column label="状态" width="" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.status=='0'">编辑中</span>
          <span v-if="scope.row.status=='1'">启用中</span>
          <span v-if="scope.row.status=='2'">已禁用</span>
          <span v-if="scope.row.status=='3'">已删除</span>
        </template>
      </el-table-column>
      <el-table-column align="right" width="150">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="train_watch(scope.row.num)">查看</el-button>
          <el-button size="mini" type="primary" @click="train_load_pdf(scope.row.num)">导出</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="train_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="train_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="train_list.total">
      </el-pagination>
    </div>
    <el-dialog :title="nav_status.title" :visible.sync="nav_status.train_watch_dialog">
      <div>
        <span v-if="train_watch_info.type=='0'">文档：
          <span v-for="(item,key) in train_watch_info.content.content" style="padding-right: 2rem;">{{item}}</span>
        </span>
        <span v-if="train_watch_info.type=='1'">公共视频：
          <span v-for="(item,key) in train_watch_info.content.content.public" style="padding-right: 2rem;">{{item}}</span>
          <br />
          内部视频：
          <span v-for="(item,key) in train_watch_info.content.content.local">{{item}}</span>
        </span>
        <br/>
         <span v-if="train_watch_info.content.subject.num!='0'">
           题库：{{train_watch_info.content.subject.subject}}<br />
           题数：{{train_watch_info.content.subject.num}}<br />
           时长：{{train_watch_info.content.subject.time}}<br />
           及格分：{{train_watch_info.content.subject.score}}<br />
           考核次数（含补考）：{{train_watch_info.content.subject.exam}}<br />
         </span>
      </div>
      <el-table stripe :data="train_watch_info.companyee" style="width: 100%">
        <el-table-column label="姓名" prop="a_id" width="" sortable>
        </el-table-column>
        <el-table-column label="部门" width="" sortable>
          <template slot-scope="scope">
            <span v-for="(item,key) in scope.row.section">{{item}}</span>
          </template>
        </el-table-column>
        <el-table-column label="完成日期" width="" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.end!='0'">{{scope.row.end}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="截止日期" prop="t_end" width="" sortable>
        </el-table-column>
        <el-table-column label="学习时长" prop="study_time" width="" sortable>
        </el-table-column>
        <el-table-column label="完成情况" width="" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'">
              <span v-if="scope.row.end>scope.row.t_end">逾期完成</span>
              <span v-else>按时完成</span>
            </span>
            <span v-else>
              <span v-if="scope.row.start=='0'">
                <span v-if="train_watch_info.today>scope.row.t_end">未进行，已逾期</span>
                <span v-else>未进行</span>
              </span>
              <span v-else>
                <span v-if="train_watch_info.today>scope.row.t_end">已逾期</span>
                <span v-else>进行中</span>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="考核情况" width="" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'">
              <span v-if="train_watch_info.content.subject.num>'0'">
                <span v-if="scope.row.status_scord=='0'">未通过</span>
                <span v-else>通过</span>
              </span>
              <span v-else>无考试</span>
            </span>
            <span v-else>
              <span v-if="train_watch_info.content.subject.num>'0'">未进行</span>
              <span v-else>无考试</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="考核情况" width="" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'">
              <span v-if="train_watch_info.content.subject.num>'0'">
                <span v-if="scope.row.status_scord=='0'">未通过</span>
                <span v-else>通过</span>
              </span>
              <span v-else>无考试</span>
            </span>
            <span v-else>
              <span v-if="train_watch_info.content.subject.num>'0'">未进行</span>
              <span v-else>无考试</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="电子签名" width="" sortable>
          <template slot-scope="scope">
            <span v-if="train_watch_info.idcard_status=='0'">NA</span>
            <span v-else>
              <span v-if="scope.row.idcard_time=='0'">
                未签名
              </span>
              <span v-else>
                {{scope.row.idcard_time}}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="结果确认状态" width="" sortable>
          <template slot-scope="scope">
            <span v-if="train_watch_info.confirm_status=='0'">NA</span>
            <span v-else>
              <span v-if="scope.row.confirm_status=='0'">
                未确认
              </span>
              <span v-else-if="scope.row.confirm_status=='1'">
                已确认
              </span>
              <span v-else>
                存在疑问
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="结果确认" width="" sortable>
          <template slot-scope="scope">
            <span v-if="train_watch_info.confirm_status=='0'">NA</span>
            <span v-else>
              <span v-if="scope.row.confirm_time=='0'">
                未确认
              </span>
              <span v-else>
                {{scope.row.confirm_time}}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="培训形式" width="" sortable>
          <span>线上培训</span>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nav_status.train_watch_dialog=false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        edittask_name:{
          dialogVisible:false,
          input:'',
          item:{}
        },
        liad_show:false,
        nav_status:{
          train_watch_dialog:false,
          title:''
        },
        train_choiced:[],
        train_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        train_watch_info:{
          content:{subject:{num:'0'}}
        },
        time:null,
        search: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    components: {
      load:load
    },
    mounted() {
      this.get_train()
    },
    methods: {
      changeEnddate(key,item){
        let _this=this
        _this.edittask_name.item=item
        _this.edittask_name.dialogVisible=true
        _this.edittask_name.input=''
        _this.edittask_name.input=item.name
      },
      edittask_ok(){
        let _this=this
        _this.edittask_name.item.name=_this.edittask_name.input
        _this.edittask_name.dialogVisible=false
      },
      search_click(){
        this.get_train()
      },
      train_load_excel(){
        let _this=this
        _this.liad_show=true
        if(_this.time==null){
          _this.time=['','']
        }
        var data={'time':_this.time,'type':'online'}
        _this.axios.post('/v2/c_census/train_down_excel',{data:data},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '任务详情.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
            _this.liad_show=false
          }else{
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.liad_show=false
        });
      },

      train_choiced_click(train){},

      train_choiced_change(train){
        let _this=this
        _this.train_choiced=[]
        for(var i=0;i<train.length;i++){
          _this.train_choiced.push(train[i].num)
        }
      },

      train_load_pdf(num){
        let _this=this
        if(num!=''){
          _this.train_choiced=[]
          _this.train_choiced.push(num)
        }
        if(_this.train_choiced.length>0){
          _this.liad_show=true
          var href='/v2/c_census/train_down_pdf?key='+localStorage.authorization+'&num='+_this.train_choiced.toString()+'&type=online'
          window.open(href,'_self')
          _this.liad_show=false
        }else{
          _this.$message.error('请选择任务')
        }

      },

      train_watch(num){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_census/get_train_info',{params:{'num':num,'type':'online'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.train_watch_info=res.data.data
              _this.nav_status.title=res.data.data.name
              _this.liad_show=false
              _this.nav_status.train_watch_dialog=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      get_train(){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_census/get_train',{params:{'page':_this.train_list.current_page,'limit':_this.train_list.per_page,'type':'online','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.train_list=res.data.data
              _this.train_list.per_page=parseInt(_this.train_list.per_page)
                _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.train_list.current_page = 1;
        this.train_list.per_page = val
        this.get_train()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.train_list.current_page = val
        _this.get_train()
      }
    },
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/census/train/train_info.vue